import { render, staticRenderFns } from "./TemplateD.vue?vue&type=template&id=d0bf047e&scoped=true&"
import script from "./TemplateD.vue?vue&type=script&lang=js&"
export * from "./TemplateD.vue?vue&type=script&lang=js&"
import style0 from "./TemplateD.vue?vue&type=style&index=0&id=d0bf047e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0bf047e",
  null
  
)

export default component.exports